import Axios from "axios";
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/master-admins/`;

// Auth
export function signIn(data) {
  const url = BASE_URL + "login";

  return Axios.post(url, data);
}

export function validateUser(token) {
  const url = BASE_URL + "validate-session";

  return Axios.post(url, {}, getConfig(token));
}

// Community
export function createCommunity(token, data) {
  const url = BASE_URL + "communities";
  const form = new FormData();

  for (const key in data) {
    form.append(key, data[key]);
  }

  return Axios.post(url, form, getConfig(token));
}

export function updateCommunity(token, id, data) {
  const url = BASE_URL + `communities/${id}`;

  return Axios.patch(url, data, getConfig(token));
}

export function deleteCommunity(token, id) {
  const url = BASE_URL + `communities/${id}`;

  return Axios.delete(url, getConfig(token));
}

export function getCommunities(token) {
  const url = BASE_URL + "communities";

  return Axios.get(url, getConfig(token));
}

// Appartments
export function createAppartment(token, id, data) {
  const url = BASE_URL + `communities/${id}/apartments`;

  return Axios.post(url, data, getConfig(token));
}

export function deleteAppartment(token, id, appartmentId) {
  const url = BASE_URL + `communities/${id}/apartments/${appartmentId}`;
  
  return Axios.delete(url, getConfig(token));
}

function getConfig(token) {
  return { headers: { authorization: "Bearer " + token } };
}



// WEBPACK FOOTER //
// ./src/components/actions/api/index.js